import React from 'react';
import { NavLink } from "react-router-dom";
import html from "../assets/images/html.png"
import css from "../assets/images/css.png"
import js from "../assets/images/js.png"
import node_js_logo from "../assets/images/node_js_logo.png"
import py from "../assets/images/py.png"
import react_js_logo from "../assets/images/react_js_logo.png"
import redux from "../assets/images/redux.png"
import flask_logo from "../assets/images/flask_logo.png"
import mongodb_logo from "../assets/images/mongodb_logo.png"
import mysql from "../assets/images/mysql.png"
import firebase from "../assets/images/firebase.png"
import django from "../assets/images/django.png"
import Footer from './Footer';
import "../assets/css/plans.css"

const Plans = () => {
    return (
      <>
        <section id="techs">
            <div className="container">
                <div className="row">
                    <div className="col col-md-12 text-center">
                        <h2 className="text-dark">Technologies we work on</h2>
                        <hr className="my-4 mx-auto" />
                        <p>Your satisfaction means the most to us!</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={html} alt="HTML" title="HTML" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={css} alt="CSS" title="CSS" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={js} alt="JavaScript" title="JavaScript" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={py} alt="Python" title="Python" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={node_js_logo} alt="Node.js" title="Node.js" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={react_js_logo} alt="ReactJS" title="ReactJS" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={redux} alt="Redux" title="Redux" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={flask_logo} alt="Flask" title="Flask" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={mongodb_logo} alt="MongoDB" title="MongoDB" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={mysql} alt="MySQL" title="MySQL" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={firebase} alt="Firebase" title="Firebase" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 text-center">
                        <div className="mx-auto toolbox mt-5">
                            <img src={django} alt="Django" title="Django" width="94px" height="94px" className="img_shake"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="plans" className="bg-white">
            <div className="container">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <h2 className="text-dark">Our Plans<br/></h2>
                        <hr className="my-4 mx-auto" />
                        <p className="text-muted mb-4">We offer different flexible plans so that you can chhose one according to your budget and requirements.<br/></p>
                        <p className="text-muted mb-4">Note: Please read <NavLink to="/terms">our terms</NavLink> to know more before placing an order.<br/></p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-10 col-md-4 col-sm-4">
                        <div className="pricingTable">
                            <div className="pricing_heading">
                                <h3 className="title">Basic Plan</h3>
                                <span className="value">
                                    Rs. 5,499
                                    <span className="month">per project</span>
                                </span>
                            </div>
                            <div className="content">
                                <ul>
                                    <li>5 (five) Pages (Dynamic Content)</li>
                                    <li>Max 50 Images &amp; Videos (Stock)</li>
                                    <li>SEO Friendly Website</li>
                                    <li>Social Media Integration</li>
                                    <li>Full Support (Phone/Email/Chat)</li>
                                </ul>
                                <div className="link">
                                    <NavLink to="/email">Let's Talk</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-10 col-md-4 col-sm-4">
                        <div className="pricingTable">
                            <div className="pricing_heading">
                                <h3 className="title">Classic Plan</h3>
                                <span className="value">
                                    Rs. 7,999
                                    <span className="month">per project</span>
                                </span>
                            </div>
                            <div className="content">
                                <ul>
                                    <li>15 (fifteen) Pages (Dynamic)</li>
                                    <li>Max 100 Images &amp; Videos (Stock)</li>
                                    <li>Responsive Website</li>
                                    <li>Performance Oriented Website</li>
                                    <li>Live Chat Integration</li>
                                </ul>
                                <div className="link">
                                    <NavLink to="/email">Let's Talk</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-10 col-md-4 col-sm-4">
                        <div className="pricingTable">
                            <div className="pricing_heading">
                                <h3 className="title">Premium Plan</h3>
                                <span className="value">
                                    Rs.12,499
                                    <span className="month">per project</span>
                                </span>
                            </div>
                            <div className="content">
                                <ul>
                                    <li>Unlimited* Dynamic Pages</li>
                                    <li>Unlimited* Images &amp; Videos</li>
                                    <li>Mobile First Website</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Secured Coding</li>
                                </ul>
                                <div className="link">
                                    <NavLink to="/email">Let's Talk</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container my-3">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <p className="text-muted mb-4"><small>* Here unlimited refers to dynamically generated contents.<br/></small></p>
                    </div>
                </div>
            </div>
            <div className="container mt-2">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <h2 className="text-dark">Your mind's playin' something else?<br/></h2>
                        <hr className="my-4 mx-auto" />
                        <p className="mb-4">We can do customised works as per your need. Let's tune our thoughts to get it done! Choose what suits you best.<br/></p>
                        <NavLink to="/email" className="btn btn-warning btn-xl js-scroll-trigger" role="button">Let Us Know!</NavLink>
                        {/* <a className="btn btn-warning btn-xl js-scroll-trigger" role="button" href="/#team">Let Us Know!</a> */}
                    </div>
                </div>
            </div>
        </section>
        <Footer />
      </>
    )
}

export default Plans